import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Lock } from "lucide-react";
import AppLayout from "@/components/layout/AppLayout";
import { useGuest } from "@/context/GuestContext";
import { usePlatform } from "@/lib/platform";

const reasonFor = (path) => (path.startsWith("/library") ? "library" : path.startsWith("/create") || path.startsWith("/studio") ? "create" : "account");

const GatePanel = () => {
  const { openAuth } = useGuest();
  const { pathname } = useLocation();
  const { registrations_open: regOpen } = usePlatform();
  const reason = reasonFor(pathname);
  useEffect(() => { openAuth({ reason }); }, [openAuth, reason]);
  return (
    <section data-testid="guest-gate" className="mx-auto flex min-h-[70vh] max-w-xl flex-col items-center justify-center px-6 pt-32 pb-16 text-center">
      <span className="grid h-16 w-16 place-items-center rounded-full border border-[#FFD86A]/60 bg-black/60 text-[#FFD86A] shadow-[0_0_40px_rgba(212,175,55,0.35)]"><Lock className="h-7 w-7" /></span>
      <h1 className="mt-6 font-display text-3xl sm:text-4xl font-bold gold-text">Sign in to continue</h1>
      <p className="mt-3 text-sm text-white/65">This part of AETRYX needs an account. You can keep browsing and watching free titles as a guest.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <button data-testid="guest-gate-signin" onClick={() => openAuth({ reason })} className="btn-gold px-7 py-3 text-sm">Sign in</button>
        {regOpen !== false && <button data-testid="guest-gate-signup" onClick={() => openAuth({ reason, mode: "register" })} className="btn-ghost-gold px-7 py-3 text-sm">Sign up free</button>}
        <Link to="/" data-testid="guest-gate-browse" className="btn-ghost-gold px-7 py-3 text-sm">Keep browsing</Link>
      </div>
    </section>
  );
};

export const GuestGate = () => <AppLayout><GatePanel /></AppLayout>;
